const storybookEnv = {
  development: 'https://develop--64e769384ef6b440f819fcec.chromatic.com/',
  production: 'https://main--64e769384ef6b440f819fcec.chromatic.com/'
};

export default storybookEnv;
